export enum RadioButtonStates {
  on = 'on',
  off = 'off'
}
